// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"41bf86f9","497":"f72f4573","611":"c4bb9a85","685":"36256d0f"}[chunkId] + ".chunk.js";
};